import React from 'react';
import Link from 'next/link';

type AccountLinkProps = {
	className?: string;
	isLoading: boolean;
	variant?: 'light' | 'dark';
	hideTextOnMobile?: boolean;
};

export default function AccountLink(props: AccountLinkProps) {
	const { className, variant = 'light', hideTextOnMobile = false } = props;

	const src = variant === 'dark' ? '/images/icons/dark-icons/Account.svg' : '/images/icons/Account.svg';

	return (
		<Link
			className={`auth-links account-link ${hideTextOnMobile ? 'hide-text-mobile' : ''} ${className ?? ''}`}
			href="/account"
			aria-label="Account"
		>
			{/* eslint-disable-next-line @next/next/no-img-element */}
			<img src={src} width={24} height={24} alt="" aria-hidden />
			<span className="account-link-text">my account</span>
		</Link>
	);
}
